export const getTwilioTrackNames = (role) => {
  const prefix = role === 1 ? "Pro-" : "";

  return {
    microphone: `${prefix}microphone`,
    camera: `${prefix}camera`,
    data: `${prefix}data`,
  };
};
